import Checkbox from 'app/components/checkbox';
function ModuleTable({ data, handleModulesSelection }) {
  return (
    <>
      {data?.length !== 0 && (
        <div className='table'>
          <table className='my-table'>
            <thead>
              <tr>
                <th>Module</th>
                <th>Select</th>
              </tr>
            </thead>

            <tbody>
              {data?.map((items, indx) => (
                <tr key={indx}>
                  <td>{items?.description}</td>
                  <td>
                    {' '}
                    <Checkbox
                      id={items?.id}
                      checked={items?.permission}
                      onChange={handleModulesSelection}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default ModuleTable;
